import { reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import { goBack } from 'react-router-redux'

import SignUp from './SignUp'
import * as validations from 'utils/validations'

const validate = validations.createValidator({
  firstName: [
    validations.required
  ],
  lastName: [
    validations.required
  ],
  email: [
    validations.required,
    validations.isEmail
  ],
  password: [
    validations.required,
    validations.minLength(8)
  ],
  passwordConfirmation: [
    validations.sameAs('password', 'la contraseña')
  ]
})

let SignUpContainer = reduxForm({
  form: 'signup',
  validate
})(SignUp)

SignUpContainer = connect(
  () => ({}),
  {goBack}
)(SignUpContainer)

export default SignUpContainer



// WEBPACK FOOTER //
// ./src/screens/App/shared/screens/SignUp/SignUpContainer.js